import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// Loads the stored structure (role-filtered by the server) once per login.
const SchemaContext = createContext({ patient: null, modules: null, reload: async () => {} });

export function SchemaProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ patient: null, modules: null, metaP: null, metaM: null, loading: true });

  const reload = useCallback(async () => {
    try {
      const [p, m] = await Promise.all([api.get("/schema/patient"), api.get("/schema/modules")]);
      setState({ patient: p.data.data, modules: m.data.data, metaP: p.data.Meta, metaM: m.data.Meta, loading: false });
    } catch (_e) {
      setState((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => {
    if (user && user.id) reload();
    else setState({ patient: null, modules: null, metaP: null, metaM: null, loading: false });
  }, [user, reload]);

  return <SchemaContext.Provider value={{ ...state, reload }}>{children}</SchemaContext.Provider>;
}

export const useSchemas = () => useContext(SchemaContext);
